export default __webpack_public_path__ + "static/media/handoff.8035a57c.png";